import { dropdownField, listField, textareaField } from '../../../utils/field-config-helpers';

export const insuranceFieldsConfig = {
  insuranceAccepted: listField(),
  outOfNetworkInsurances: listField(),
  insuranceInfo: textareaField(),
  noInsuranceInfo: textareaField(),
  collectInsurance: dropdownField(),
};

export type InsuranceFieldsConfigTypes = typeof insuranceFieldsConfig;
